import { useEffect, useRef } from "react"
import { navigate } from "gatsby"

const useStackbitLocale = (location, formattedRegion, region, languages) => {
  const selfTriggeredSwitch = useRef(false)

  useEffect(() => {
    if (window && typeof window !== "undefined") {
      const handler = event => {
        if (selfTriggeredSwitch.current) {
          selfTriggeredSwitch.current = false
          return
        }

        let stackbitLocale = event.detail?.locale?.toLowerCase()
        const pathname = location.pathname
          .replace(location.pathname.split("/")[1], "")
          .replace("/", "")

        if (!stackbitLocale || stackbitLocale === "en-us") {
          stackbitLocale = "en"
        }

        const language = languages.reduce((acc, lang) => {
          if (lang?.code?.toLowerCase() === stackbitLocale?.toLowerCase()) {
            acc = lang
          }
          return acc
        }, {})

        if (JSON.stringify(language) === "{}") {
          return
        } else if (
          location?.host?.includes("localhost:8090") ||
          location?.host?.includes("create.netlify.com") ||
          location?.host?.includes("stackbit.dev")
        ) {
          localStorage.setItem(
            "languageSettings",
            JSON.stringify({
              region: formattedRegion?.region,
              machineName: formattedRegion?.machineName,
              language: language,
            })
          )
        }

        navigate(`/${stackbitLocale}${pathname}`)
      }

      window.addEventListener("stackbitLocaleChanged", handler)
      return () => {
        window.removeEventListener("stackbitLocaleChanged", handler)
      }
    }
  }, [languages, region])
}

export default useStackbitLocale
